import { render, staticRenderFns } from "./cloudbackups.vue?vue&type=template&id=65e48c90&scoped=true&"
import script from "./cloudbackups.vue?vue&type=script&lang=tsx&"
export * from "./cloudbackups.vue?vue&type=script&lang=tsx&"
import style0 from "./cloudbackups.vue?vue&type=style&index=0&id=65e48c90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e48c90",
  null
  
)

export default component.exports